<script>
	import Header from '../page/side/_header.svelte'
    import Footer from '../page/side/_footer.svelte'
    import ViewButton from '../page/detail/viewButton.svelte'
    import ViewTitle from '../page/detail/viewTitle.svelte'
    import ViewTab from '../page/detail/viewTab.svelte'
    import ModalLoading from '../page/side/modalLoading.svelte'
    import ModalEdit from '../page/detail/modal/modalEdit.svelte'

	import { onMount } from 'svelte'
    import { SettingCheck } from '../script/_init'
    import { CheckDevice, Initialsetting } from '../script/_handle'
    import { ContentsData, GetContentsDetail, ViewDetailPage } from '../script/handle/detail'

    export let Num
    let checkDevice = 1, OnCapture = false
    let ShowLoadingModal = false, ShowEditModal = false

    let contents
    ContentsData.subscribe(value => {contents = value})
    
	onMount(async () => {
		checkDevice = CheckDevice()

        // 페이지 초기 세팅
		//await Initialsetting()

        await GetContentsDetail(Num)

        await ViewDetailPage(Num)
    })
</script>

<svelte:window on:resize={() => checkDevice = CheckDevice()} />

<svelte:head>
    {#if contents == undefined || contents.title == undefined}
	    <title>Detail Loading...</title>
    {:else}
	    <title>[{contents.num}]{contents.title}</title>
    {/if}
</svelte:head>

<Header />

<div class="page">
    {#if checkDevice == 1}
        <div class="adfit pc vertical">
            <ins class="kakao_ad_area" style="display:none;"
            data-ad-unit = "DAN-FiXDp3vAveansjCX"
            data-ad-width = "160"
            data-ad-height = "600"></ins>
        </div>
    {:else}
        <div class="adfit mobile horizon">
            <ins class="kakao_ad_area" style="display:none;"
            data-ad-unit = "DAN-ejTHClwjUeFmA2p2"
            data-ad-width = "320"
            data-ad-height = "50"></ins>
        </div>
    {/if}

    <div class="content">
        {#if contents != undefined}
            {#if $SettingCheck}
                {#if contents == undefined || contents.title == undefined}
                    <div class="issue">Wating...</div>
                {:else}
                    <ViewTitle
                        bind:Num={contents.num}
                        bind:Title={contents.title}
                    />

                    <ViewButton
                        bind:Num={contents.num}
                        bind:OnCapture
                        bind:ShowLoadingModal
                        bind:ShowEditModal
                    />
                {/if}
            {/if}

            <div class="adfit mobile horizon">
                <ins class="kakao_ad_area" style="display:none;"
                data-ad-unit = "DAN-Ts61CY3bo3stg7DB"
                data-ad-width = "320"
                data-ad-height = "50"></ins>
            </div>

            {#if $SettingCheck}
                {#if contents == undefined || contents.title == undefined}
                    <div class="issue">Wating...</div>
                {:else}
                    <ViewTab
                        bind:Device={checkDevice}
                        bind:OnCapture
                        bind:Contents={contents}
                    />
                {/if}
            {/if}
        {/if}
    </div>

    {#if checkDevice == 1}
        <div class="adfit pc vertical">
            <ins class="kakao_ad_area" style="display:none;"
            data-ad-unit = "DAN-ReGZIZUzMcwgqh1n"
            data-ad-width = "160"
            data-ad-height = "600"></ins>
        </div>
    {:else}
        <div class="adfit mobile horizon">
            <ins class="kakao_ad_area" style="display:none;"
            data-ad-unit = "DAN-eDXKnSwlGWeojks3"
            data-ad-width = "320"
            data-ad-height = "50"></ins>
        </div>
    {/if}

	<!-- Kakao Adfit -->
	<script type="text/javascript" src="//t1.daumcdn.net/kas/static/ba.min.js" async></script>
</div>

<Footer />

{#if ShowLoadingModal}
    <ModalLoading bind:ShowLoadingModal bind:OnCapture CountTimer={3} />
{/if}

{#if ShowEditModal}
    <ModalEdit bind:Num bind:ShowEditModal />
{/if}

<style lang='scss'>
    .issue {
        color: $cl4;
        font-size: 24px;
        font-family: aggro;
    }
</style>